export const checkKeyCombinations = (event: React.KeyboardEvent) => {
    const isModifierPressed = event.ctrlKey || event.altKey || event.shiftKey || event.metaKey;
    const isKeyCombination =
        isModifierPressed && event.key !== 'Control' && event.key !== 'Shift' && event.key !== 'Alt' && event.key !== 'Meta';

    return { isModifierPressed, isKeyCombination };
};